import { useRef as v, useEffect as y, useState as H } from "react";
import { useEvent as m, useSafeLayoutEffect as W, useTagName as X, useForkRef as _ } from "../../../ariakit-react-utils/esm/hooks.js";
import { createHook as j, createComponent as z, createElement as J } from "../../../ariakit-react-utils/esm/system.js";
import { isButton as Q } from "../../../ariakit-utils/esm/dom.js";
import { addGlobalEventListener as L, isPortalEvent as Y, queueBeforeEvent as x, isSelfTarget as A, isFocusEventOutside as Z } from "../../../ariakit-utils/esm/events.js";
import { isFocusable as $, focusIfNeeded as ee, hasFocus as te } from "../../../ariakit-utils/esm/focus.js";
import { queueMicrotask as D } from "../../../ariakit-utils/esm/misc.js";
import { isSafari as re } from "../../../ariakit-utils/esm/platform.js";
const M = re(), ne = ["text", "search", "url", "tel", "email", "password", "number", "date", "month", "week", "time", "datetime", "datetime-local"];
function ue(e) {
  const {
    tagName: r,
    readOnly: s,
    type: f
  } = e;
  return r === "TEXTAREA" && !s || r === "SELECT" && !s ? !0 : r === "INPUT" && !s ? ne.includes(f) : !!e.isContentEditable;
}
function se(e) {
  return e.getAttribute("role") === "combobox";
}
function oe(e) {
  return "labels" in e ? e.labels : null;
}
function V(e) {
  return e.tagName.toLowerCase() === "input" && e.type ? e.type === "radio" || e.type === "checkbox" : !1;
}
function ie(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" || e === "a" : !0;
}
function fe(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" : !0;
}
function ae(e, r, s, f, i) {
  return e ? r ? s && !f ? -1 : void 0 : s ? i : i || 0 : i;
}
function T(e, r) {
  return m((s) => {
    e == null || e(s), !s.defaultPrevented && r && (s.stopPropagation(), s.preventDefault());
  });
}
let g = !0;
function ce(e) {
  const r = e.target;
  r && "hasAttribute" in r && (r.hasAttribute("data-focus-visible") || (g = !1));
}
function le(e) {
  e.metaKey || e.ctrlKey || (g = !0);
}
const de = j((e) => {
  let {
    focusable: r = !0,
    accessibleWhenDisabled: s,
    autoFocus: f,
    onFocusVisible: i,
    ...u
  } = e;
  const b = v(null);
  y(() => {
    r && (L("mousedown", ce, !0), L("keydown", le, !0));
  }, [r]), M && y(() => {
    if (!r) return;
    const t = b.current;
    if (!t || !V(t)) return;
    const n = oe(t);
    if (!n) return;
    const o = () => D(() => t.focus());
    return n.forEach((d) => d.addEventListener("mouseup", o)), () => {
      n.forEach((d) => d.removeEventListener("mouseup", o));
    };
  }, [r]);
  const a = r && u.disabled, p = !!a && !s, [c, l] = H(!1);
  y(() => {
    r && p && c && l(!1);
  }, [r, p, c]), y(() => {
    if (!r || !c) return;
    const t = b.current;
    if (!t || typeof IntersectionObserver > "u") return;
    const n = new IntersectionObserver(() => {
      $(t) || l(!1);
    });
    return n.observe(t), () => n.disconnect();
  }, [r, c]);
  const I = T(u.onKeyPressCapture, a), O = T(u.onMouseDownCapture, a), S = T(u.onClickCapture, a), E = u.onMouseDown, B = m((t) => {
    if (E == null || E(t), t.defaultPrevented || !r) return;
    const n = t.currentTarget;
    if (!M || Y(t) || !Q(n) && !V(n)) return;
    let o = !1;
    const d = () => {
      o = !0;
    }, U = {
      capture: !0,
      once: !0
    };
    n.addEventListener("focusin", d, U), x(n, "mouseup", () => {
      n.removeEventListener("focusin", d, !0), !o && ee(n);
    });
  }), h = (t, n) => {
    if (n && (t.currentTarget = n), i == null || i(t), t.defaultPrevented || !r) return;
    const o = t.currentTarget;
    o && te(o) && l(!0);
  }, w = u.onKeyDownCapture, N = m((t) => {
    if (w == null || w(t), t.defaultPrevented || !r || c || t.metaKey || t.altKey || t.ctrlKey || !A(t)) return;
    const n = t.currentTarget;
    D(() => h(t, n));
  }), F = u.onFocusCapture, P = m((t) => {
    if (F == null || F(t), t.defaultPrevented || !r) return;
    if (!A(t)) {
      l(!1);
      return;
    }
    const n = t.currentTarget, o = () => h(t, n);
    g || ue(t.target) ? D(o) : se(t.target) ? x(t.target, "focusout", o) : l(!1);
  }), C = u.onBlur, R = m((t) => {
    C == null || C(t), r && Z(t) && l(!1);
  });
  W(() => {
    var t;
    r && f && ((t = b.current) == null || t.focus());
  }, [r, f]);
  const K = X(b, u.as), G = r && ie(K), k = r && fe(K), q = p ? {
    pointerEvents: "none",
    ...u.style
  } : u.style;
  return u = {
    "data-focus-visible": r && c ? "" : void 0,
    "aria-disabled": a ? !0 : void 0,
    ...u,
    ref: _(b, u.ref),
    style: q,
    tabIndex: ae(r, p, G, k, u.tabIndex),
    disabled: k && p ? !0 : void 0,
    // TODO: Test Focusable contentEditable.
    contentEditable: a ? void 0 : u.contentEditable,
    onKeyPressCapture: I,
    onClickCapture: S,
    onMouseDownCapture: O,
    onMouseDown: B,
    onKeyDownCapture: N,
    onFocusCapture: P,
    onBlur: R
  }, u;
}), be = z((e) => (e = de(e), J("div", e)));
process.env.NODE_ENV !== "production" && (be.displayName = "Focusable");
export {
  be as Focusable,
  de as useFocusable
};
//# sourceMappingURL=focusable.js.map
